var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHistory01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.65 6.228A8.45 8.45 0 0 1 12 4.324v.8-.8A7.676 7.676 0 1 1 4.324 12v-.8h1.6v.8A6.075 6.075 0 1 0 12 5.924 6.85 6.85 0 0 0 7.66 7.467l-.62.506-1.012-1.24z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.658 4.154 1.552.388-.529 2.116 2.116.529-.388 1.552-3.668-.917zM12.8 7.498v5.525L8.89 14.977l-.715-1.431 3.023-1.512V7.498z"
}))));
export default SvgIconHistory01;